<template>
  <BoardView :title="user.lastName">
    <FormValidation @submit="saveUser(user)">
      <FormUser type="admin" :user="user" />
      <Btn v-if="hasRole('>=ADMIN')" class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardSingle from '@mixins/BoardSingle'
import FormUser from '@forms/FormUser'
import { omit } from 'rambda'

export default {
  mixins: [BoardSingle('user')],
  components: { FormUser },
  methods: {
    saveUser(user) {
      const userToSave = user.password
        ? user
        : omit(['password', 'passwordMatch'], user)

      return this.save(userToSave)
    },
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "submit": "Update"
  }
}
</i18n>
